export const REQUEST_COMBO_UPSELLS = 'REQUEST_COMBO_UPSELLS';
export const REQUEST_COMBO_UPSELLS_SUCCESS = 'REQUEST_COMBO_UPSELLS_SUCCESS';
export const REQUEST_COMBO_UPSELLS_FAILURE = 'REQUEST_COMBO_UPSELLS_FAILURE';
